<template>
  <div>
    <wiki-home-top />
    <div class="contributor-list">
      <h1 class="title">《{{ detail.title || "" }}》的主要贡献者</h1>
      <el-table :data="list" border style="width: 100%" v-loading="loading">
        <el-table-column prop="user" label="用户名" align="center">
          <template slot-scope="{ row }">
            <a :href="`/user/index/${row.user.uid}.html`">{{ row.user.username }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="total_count" label="修订版本数" width="132" align="center"> </el-table-column>
        <el-table-column prop="start_at" label="首次编辑日期" align="center">
          <template slot-scope="{ row }">
            {{ dayjs(row.start_at * 1000).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column prop="end_at" label="最后编辑日期" align="center">
          <template slot-scope="{ row }">
            {{ dayjs(row.end_at * 1000).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
// components
import WikiHomeTop from "@/views/wiki/components/wikiHomeTop";
// api
import { apiGetDetailContributor, apiContentDetail } from "@/api/contentApi";

export default {
  name: "ContributorList",
  components: {
    WikiHomeTop
  },
  data() {
    return {
      detail: {},
      list: [],
      loading: false
    };
  },
  beforeMount() {
    this.getDetail();
    this.getList();
  },
  mounted() {},

  methods: {
    dayjs,
    // 获取详情
    async getDetail() {
      try {
        const contentId = this.$route.query.contentId;
        const { code, data } = await apiContentDetail({
          id: contentId
        });
        if (code === 0) {
          this.detail = data || {};
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取贡献者列表
    async getList() {
      try {
        this.loading = true;
        const contentId = this.$route.query.contentId;
        this.contentTitle = this.$route.query.title;
        const { code, data } = await apiGetDetailContributor({
          content_id: contentId
        });
        if (code === 0) {
          this.list = data || [];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.contributor-list {
  width: 1380px;
  height: 901px;
  background: #ffffff;
  border-radius: 8px;
  border: 12px solid rgba(174, 181, 203, 0.45);
  padding: 95px 106px;
  margin-top: 12px;
  .title {
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    margin-bottom: 24px;
  }

  a {
    color: #2978f7;
  }

  /deep/ .el-table__header-wrapper th {
    background-color: #f3f4f7;
    color: #212121;
  }
}
</style>
